<template>
  <div class="schema-designer-container-9136076486841527" v-if="loadState">
    <div class="content">
        <!-- 左侧控件区域 start -->
        <aside class="left">
            <CsimVisitFormPeriod
              @handleSetPeriod="handleSetPeriod"
              @handleSelectForm="handleSelectForm"
              ref="CsimVisitFormPeriod"
            />
        </aside>
        <!-- 左侧控件区域 end -->

        <!-- 中间面板区域 start -->
       <section style="background-color: #fafafa;">
            <CsimVisitFormContent
              :model="model"
              ref="CsimVisitFormContent"
            />
        </section>
        <!-- 中间面板区域 end -->

        <!-- 右侧控件属性区域 start -->
        <aside class="right">
          <CsimVisitFormItem
            ref="CsimVisitFormItem"
            :selectForm="selectForm"
          />
        </aside>
        <!-- 右侧控件属性区域 end -->
      </div>
  </div>
</template>

<script>
import "./styles/visit-design.less";

import CsimVisitFormPeriod from "./module/CsimVisitFormPeriod";
import CsimVisitFormContent from "./module/CsimVisitFormContent";
import CsimVisitFormItem from "./module/CsimVisitFormItem";

export default {
  name: "csimVisitDesign",
  props: {

  },
  components: {
    CsimVisitFormPeriod,
    CsimVisitFormContent,
    CsimVisitFormItem,
  },
  data() {
    return {
      loadState: false,
      model: {
        id: "",
        formList:[]
      },
      selectForm: {}
    };
  },
  methods: {
    // NONE
    handleSetPeriod(record) {
      this.model = record;
    },
    handleSelectForm(record) {
      this.selectForm = record;
      this.$refs.CsimVisitFormItem.formPreviewHandle(record);
    }
  },
  created() {
    this.loadState = true;
  }
};
</script>
